export const selectAllTextInDiv = (divId: string) => {
  const element = document.getElementById(divId);
  if (!element) {
    return;
  }

  const range = document.createRange();
  range.selectNodeContents(element);

  const selection = window.getSelection();
  if (selection) {
    selection.removeAllRanges();
    selection.addRange(range);
  }
};

export const copyTextToClipboard = async (text: string) => {
  if (!text) {
    console.warn("No text to copy.");
    return;
  }

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Text copied to clipboard using Clipboard API.");
    } catch (error) {
      console.error("Failed to copy text using Clipboard API:", error);
    }
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.top = "-9999px";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      console.log("Text copied to clipboard using fallback method.");
    } catch (err) {
      console.error("Fallback: Could not copy text", err);
    }
    document.body.removeChild(textArea);
  }
};
